import React, { useState } from "react";
import styled from "styled-components";
import { FONTS, COLORS, BREAKPOINTS } from "../../utils/styleConstants";

const DARK_BLUE = "#20376e";
const ACCENT_ORANGE = "#ff7057";

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: white;
  border-radius: 1.5rem;
  padding: 2rem;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
`;

const ModalTitle = styled.h3`
  margin-top: 0;
  font-size: 1.25rem;
  color: ${DARK_BLUE};
`;

const ModalMessage = styled.p`
  color: #444;
  line-height: 1.5;
`;

const TextAreaContainer = styled.div`
  margin-top: 1.5rem;
`;

const TextAreaLabel = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: ${DARK_BLUE};
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 0.75rem;
  font-family: ${FONTS.PRIMARY};
  border: 1px solid #ddd;
  border-radius: 1rem;
  resize: vertical;
  min-height: 100px;
  
  &:focus {
    outline: none;
    border-color: ${ACCENT_ORANGE};
    box-shadow: 0 0 0 2px rgba(255, 112, 87, 0.25);
  }
`;

const ModalButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 2rem;
  gap: 1rem;
`;

const Button = styled.button`
  padding: 0.75rem 1.5rem;
  border-radius: 1.5rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  font-family: ${FONTS.PRIMARY};
`;

const DangerButton = styled(Button)`
  background-color: #f44336;
  color: white;
  border: none;
  
  &:hover {
    background-color: #d32f2f;
  }
  
  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(244, 67, 54, 0.5);
  }
  
  &:disabled {
    background-color: #a0a0a0;
    cursor: not-allowed;
  }
`;

const OutlineButton = styled(Button)`
  background-color: transparent;
  color: ${ACCENT_ORANGE};
  border: 1px solid ${ACCENT_ORANGE};
  
  &:hover {
    background-color: #fff0e8;
  }
  
  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(255, 112, 87, 0.5);
  }
  
  &:disabled {
    color: #a0a0a0;
    border-color: #a0a0a0;
    cursor: not-allowed;
  }
`;

const RejectModal = ({ isOpen, onClose, onConfirm, isProcessing = false }) => {
  const [rejectReason, setRejectReason] = useState("");
  
  if (!isOpen) return null;
  
  const handleReject = () => {
    onConfirm(rejectReason);
  };

  return (
    <ModalOverlay>
      <ModalContent>
        <ModalTitle>Confirmar Rechazo</ModalTitle>
        <ModalMessage>
          Recuerda que rechazar esta Oferta Vinculante puede llevar a la otra parte a iniciar acciones legales en tu contra, y que, para el eventual trámite de Costas Procesales (posible petición de exoneración o moderación), te aconsejamos incluir el motivo de tu rechazo.
        </ModalMessage>
        
        <TextAreaContainer>
          <TextAreaLabel>Motivo del rechazo (opcional)</TextAreaLabel>
          <TextArea
            placeholder="Indique el motivo por el que rechaza la oferta..."
            value={rejectReason}
            onChange={(e) => setRejectReason(e.target.value)}
            disabled={isProcessing}
          />
        </TextAreaContainer>
        
        <ModalButtons>
          <OutlineButton onClick={onClose} disabled={isProcessing}>
            No
          </OutlineButton>
          <DangerButton onClick={handleReject} disabled={isProcessing}>
            {isProcessing ? "Procesando..." : "Sí"}
          </DangerButton>
        </ModalButtons>
      </ModalContent>
    </ModalOverlay>
  );
};

export default RejectModal; 